"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Mast = _interopRequireDefault(require("../../Headers/Mast"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var Offset = _styledComponents["default"].div.withConfig({
  displayName: "Inlay__Offset",
  componentId: "sc-13h37e2-0"
})(["background-color:white;margin:-15vh auto 2rem;max-width:100%;padding:2rem;position:relative;width:1170px;"]); // eslint-disable-next-line


var Inlay = function Inlay(_ref) {
  var HeaderProps = _ref.HeaderProps,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Mast["default"], _extends({}, HeaderProps, {
    offset: 15
  })), /*#__PURE__*/_react["default"].createElement(Offset, null, children));
};

var _default = Inlay;
exports["default"] = _default;